module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_f_leucistic.1e16b64b.png";